import react from "react";

import scotiabank1 from "../images/commercials/ScotiaBank/SCOTIA_BANK_001 Large.jpeg";
import scotiabank2 from "../images/commercials/ScotiaBank/SCOTIA_BANK_002 Large.jpeg";
import scotiabank3 from "../images/commercials/ScotiaBank/SCOTIA_BANK_003 Large.jpeg";
import scotiabank4 from "../images/commercials/ScotiaBank/SCOTIA_BANK_004 Large.jpeg";
import scotiabank5 from "../images/commercials/ScotiaBank/SCOTIA_BANK_005 Large.jpeg";
import scotiabank6 from "../images/commercials/ScotiaBank/SCOTIA_BANK_006 Large.jpeg";
import scotiabank7 from "../images/commercials/ScotiaBank/SCOTIA_BANK_007 Large.jpeg";
import scotiabank8 from "../images/commercials/ScotiaBank/SCOTIA_BANK_008 Large.jpeg";
import scotiabank9 from "../images/commercials/ScotiaBank/SCOTIA_BANK_009 Large.jpeg";
import scotiabank10 from "../images/commercials/ScotiaBank/SCOTIA_BANK_010 Large.jpeg";
import scotiabank11 from "../images/commercials/ScotiaBank/SCOTIA_BANK_011 Large.jpeg";
import scotiabank12 from "../images/commercials/ScotiaBank/SCOTIA_BANK_012 Large.jpeg";
import scotiabank13 from "../images/commercials/ScotiaBank/SCOTIA_BANK_013 Large.jpeg";
import scotiabank14 from "../images/commercials/ScotiaBank/SCOTIA_BANK_014 Large.jpeg";
import scotiabank15 from "../images/commercials/ScotiaBank/SCOTIA_BANK_015 Large.jpeg";
import scotiabank16 from "../images/commercials/ScotiaBank/SCOTIA_BANK_016 Large.jpeg";
import scotiabank17 from "../images/commercials/ScotiaBank/SCOTIA_BANK_017 Large.jpeg";
import scotiabank18 from "../images/commercials/ScotiaBank/SCOTIA_BANK_018 Large.jpeg";
import scotiabank19 from "../images/commercials/ScotiaBank/SCOTIA_BANK_019 Large.jpeg";
import scotiabank20 from "../images/commercials/ScotiaBank/SCOTIA_BANK_020 Large.jpeg";
import scotiabank21 from "../images/commercials/ScotiaBank/SCOTIA_BANK_021 Large.jpeg";

const scotiabank = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={scotiabank1} alt="Scotia Bank Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank2} alt="Scotia Bank Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank3} alt="Scotia Bank Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank4} alt="Scotia Bank Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank5} alt="Scotia Bank Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank6} alt="Scotia Bank Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank7} alt="Scotia Bank Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank8} alt="Scotia Bank Commercial Photography - Image 8"/>
                </div>
                 <div className="single portrait">
                    <img src={scotiabank9} alt="Scotia Bank Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank10} alt="Scotia Bank Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank11} alt="Scotia Bank Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank12} alt="Scotia Bank Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank13} alt="Scotia Bank Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank14} alt="Scotia Bank Commercial Photography - Image 14"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank15} alt="Scotia Bank Commercial Photography - Image 15"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank16} alt="Scotia Bank Commercial Photography - Image 16"/>
                </div>
                 <div className="single portrait">
                    <img src={scotiabank17} alt="Scotia Bank Commercial Photography - Image 17"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank18} alt="Scotia Bank Commercial Photography - Image 18"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank19} alt="Scotia Bank Commercial Photography - Image 19"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank20} alt="Scotia Bank Commercial Photography - Image 20"/>
                </div>
                <div className="single portrait">
                    <img src={scotiabank21} alt="Scotia Bank Commercial Photography - Image 21"/>
                </div>
               x
            </div>
        </div>
    );
}

export default scotiabank;